export default __webpack_public_path__ + "static/image-12-24bc0b79f582f899b57a246942efb9ad.jpg";